//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productionRoutingMenu', {
//        templateUrl: 'views/components/views/productionRoutingMenu/productionRoutingMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'productionRoutingService', 'ttGridFactory', function ($stateParams, stateService, productionRoutingService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let productionRoutingKeyno = $stateParams.productionrouting_keyno;

//            vm.model = {
//                productionRoutingButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('productionrouting', { productionrouting_keyno: vm.model.menu.productionrouting_keyno }) }
//                ],
//                menu: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_productionroutingwork_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setCustomToolbarButtons([{
//                name: 'productionroutingwork_new',
//                text: 'productionroutingwork_new',
//                func: () => {
//                    stateService.go('productionroutingwork', {
//                    	productionroutingwork_keyno: '0',
//                    	productionrouting_keyno: vm.model.menu.productionrouting_keyno
//                    });
//                },
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true
//            }]);
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await productionRoutingService.getEdit({ productionrouting_keyno: productionRoutingKeyno }))[0];

//                loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3652,
//                    parameters: vm.model.menu   
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//            	loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
